import { C } from "./data";

export const Shield = ({ size = 34, light = false }) => (
  <svg width={size} height={size * 1.18} viewBox="0 0 60 71" aria-label="ResQ1">
    <defs>
      <clipPath id={`sh-${size}-${light}`}>
        <path d="M4 6 Q4 1 9 1 L51 1 Q56 1 56 6 L56 38 Q56 55 30 70 Q4 55 4 38 Z" />
      </clipPath>
    </defs>
    <g clipPath={`url(#sh-${size}-${light})`}>
      <rect width="60" height="71" fill={C.red} />
      <path d="M-4 44 L30 20 L37 28 L3 56 Z" fill={light ? "#fff" : C.body} />
    </g>
  </svg>
);

export const Wordmark = ({ light = false }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
    <Shield size={26} light={light} />
    <div style={{ lineHeight: 1 }}>
      <div style={{ fontWeight: 900, fontSize: 18, letterSpacing: "-0.03em", color: light ? "#fff" : C.ink }}>
        RESQ<span style={{ color: C.red }}>1</span>
      </div>
      <div style={{ fontSize: 8, letterSpacing: "0.22em", textTransform: "uppercase", color: light ? "rgba(255,255,255,0.6)" : C.slate, fontFamily: "'JetBrains Mono', monospace", marginTop: 2 }}>
        Emergency Protection
      </div>
    </div>
  </div>
);

export const Label = ({ children, style }) => (
  <div style={{ fontSize: 10, letterSpacing: "0.16em", textTransform: "uppercase", color: C.slate, fontFamily: "'JetBrains Mono', monospace", ...style }}>
    {children}
  </div>
);

export const Serif = ({ children, size = 26, style }) => (
  <div style={{ fontFamily: "'Fraunces', Georgia, serif", fontWeight: 500, letterSpacing: "-0.022em", color: C.ink, fontSize: size, lineHeight: 1.1, ...style }}>
    {children}
  </div>
);

export const Card = ({ children, style, ...rest }) => (
  <div style={{ background: "#fff", border: "1px solid rgba(26,30,36,0.08)", borderRadius: 12, padding: 16, ...style }} {...rest}>
    {children}
  </div>
);

export const Avatar = ({ name, color = C.navy }) => (
  <div style={{ width: 38, height: 38, borderRadius: "50%", background: color, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, flexShrink: 0 }}>
    {name.split(" ").map((x) => x[0]).slice(0, 2).join("")}
  </div>
);
